import { type ComponentPropsWithoutRef, memo } from "react"

import { IconWrapper, type IconWrapperProps } from "./IconWrapper"
import { LuDynamicIcon } from "./LuDynamicIcon"

export interface LuDynamicIconWithWrapperProps
	extends
		Omit<IconWrapperProps, "children">,
		Pick<ComponentPropsWithoutRef<typeof LuDynamicIcon>, "icon" | "fallback" | "size"> {}

export const LuDynamicIconWithWrapper = memo<LuDynamicIconWithWrapperProps>((props) => {
	const { ref, icon, fallback, color, size, ...rest } = props

	return (
		<IconWrapper ref={ref} color={color} {...rest}>
			<LuDynamicIcon icon={icon} color={color} fallback={fallback} size={size} />
		</IconWrapper>
	)
})
LuDynamicIconWithWrapper.displayName = "LuDynamicIconWithWrapper"
